import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import RoundedButton from "./RoundedButton";

const Wrapper = styled(RoundedButton)`
  background-color: ${({ theme }) => theme.palette.primary};
  color: ${({ theme }) => theme.palette.white};
  border: 1px solid transparent;

  &:disabled {
    background-color: ${({ theme }) => theme.palette.grey.light};
  }
  &.secondary {
    color: ${({ theme }) => theme.palette.secondary};
    background-color: ${({ theme }) => theme.palette.white};
    border-color: inherit;
  }
`;

const Button = ({ className, variation, children, onClick, ...rest }) => {
  const classes = ["Button"];
  if (className) classes.push(className);
  if (variation) classes.push(variation);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Wrapper className={classes.join(" ")} onClick={onClick} {...rest}>
      {children}
    </Wrapper>
  );
};

Button.displayName = "Button";

Button.propTypes = {
  className: PropTypes.string,
  variation: PropTypes.oneOf(["primary", "secondary"]),
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
};

Button.defaultProps = {
  className: null,
  variation: "primary",
  children: null,
};

export default Button;
